import SkeletonCheckout from "./SkeletonCheckout";

export default SkeletonCheckout;
